import React from "react";
import { Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = "mdeniz.info@gmail.com";
const EFFECTIVE_DATE = "October 19, 2026";
const APP_NAME = "Hair Try On";

function PrivacyPolicy() {
  const App = () => <span style={{ fontWeight: "bold" }}>{APP_NAME}</span>;

  const H = ({ children, id }) => (
    <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5} id={id}>
      {children}
    </Text>
  );
  const SH = ({ children }) => (
    <Text fontSize="m" color="#fff" fontWeight="bold" mt={6} mb={3}>
      {children}
    </Text>
  );
  const P = ({ children }) => (
    <Text fontSize="m" color="#fff" mt={5} mb={5}>
      {children}
    </Text>
  );
  const Li = ({ children }) => (
    <Text fontSize="m" color="#fff" mt={3} mb={3} ml={4}>
      • {children}
    </Text>
  );
  const Ext = ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "underline", color: "#fff" }}
    >
      {children}
    </a>
  );

  return (
    <div className="container">
      <div className="header">
        <div className="header__right">
          <a href="/">
            <Text fontWeight="black" color="#fff" fontSize={20}>
              Muhammed Deniz
            </Text>
          </a>
        </div>

        <div className="header__left">
          <Link to="/home">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Home
            </Text>
          </Link>

          <Link to="/hairtryon/privacypolicy">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Privacy Policy
            </Text>
          </Link>

          <Link to="/hairtryon/termsofuse">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Terms Of Use
            </Text>
          </Link>
        </div>
      </div>

      <div style={{ margin: 60, marginLeft: "10%", marginRight: "15%" }}>
        <Text fontSize="xl" mb={5} fontWeight="black" color="#fff">
          Privacy Policy
        </Text>

        <P>
          Your privacy is important to us. It is Muhammed Deniz's policy to
          respect your privacy regarding any information we may collect from you
          through our app, <App />.
        </P>

        <P>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we’re collecting it
          and how it will be used.
        </P>

        <P>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we’ll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </P>

        <P>
          We don’t sell your personal information, and we don’t share any
          personally identifying information publicly or with third parties,
          except as described in this policy (for example, the AI and service
          providers that make the app work) or when required to by law.
        </P>

        <P>
          Our app may link to external sites that are not operated by us. Please
          be aware that we have no control over the content and practices of
          these sites, and cannot accept responsibility or liability for their
          respective privacy policies.
        </P>

        <P>
          Your continued use of our app will be regarded as acceptance of our
          practices around privacy and personal information. If you have any
          questions about how we handle user data and personal information, feel
          free to contact us at{" "}
          <Ext href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Ext>.
        </P>

        <P>This policy is effective as of {EFFECTIVE_DATE}.</P>

        {/* ------------------------------------------------------------ */}
        <H id="information-we-collect">1. Information We Collect and How</H>

        <P>
          <App /> lets you try new hairstyles and hair colors on a photo of
          yourself. It does not require you to create an account, and we do not
          ask for your name, email address, phone number, contacts or location.
          The information below is what the app and our service providers
          handle.
        </P>

        <SH>Photos you choose to submit</SH>
        <Li>
          The photo you select or take (which may show your face) and the
          hairstyle or hair color you pick are collected only when you tap the
          button to create a result.
        </Li>
        <Li>
          Before the first time a photo is sent to a third-party AI service, the
          app asks for your explicit permission (see “Consent and How to
          Withdraw It”).
        </Li>
        <Li>
          The app only accesses the photos you choose through the system photo
          picker or camera. It does not browse your photo library.
        </Li>
        <Li>
          If you tap Download or Save, the result is saved to your device’s
          photo library.
        </Li>

        <SH>Anonymous app identifier and purchase information</SH>
        <Li>
          A random, anonymous app user ID created by RevenueCat, our
          subscription provider. It is used to check your subscription status,
          to apply fair-use limits and to prevent abuse. It is not linked to
          your name or email.
        </Li>
        <Li>
          Purchase and subscription information (product, status, dates)
          processed by Apple App Store / Google Play and RevenueCat. We never
          receive your payment card details.
        </Li>

        <SH>Usage and diagnostics</SH>
        <Li>
          Google Firebase Analytics may collect app interactions, device and OS
          information, and device or app-instance identifiers, to help us
          understand how the app is used and fix problems.
        </Li>
        <Li>
          If you allow the tracking permission prompt shown by the app, your
          device’s advertising identifier may also be available to our analytics
          provider for app analytics and for measuring the app’s performance
          (see “Tracking and Advertising”).
        </Li>

        <SH>Safety, reports and support</SH>
        <Li>
          When you use the app’s Report button, we receive the reason and
          details you enter, the app name, and the ID of the reported result.
          The report does not include your photo or the generated image.
        </Li>
        <Li>
          If you email us, we receive your email address and what you write.
        </Li>
        <Li>
          To prevent abuse, our servers briefly process your anonymous app user
          ID, request counts, the IP address of your request (for short-term
          rate limiting), and the result of automated safety checks.
        </Li>
        <Li>
          We keep a record linking a generated result to your anonymous app user
          ID and the time it was created, so that only you can retrieve it and
          so that we can act on abuse reports. This record does not contain your
          photo.
        </Li>

        <SH>Data kept only on your device</SH>
        <Li>
          Your selected photos, results and creation history are stored locally
          on your device. They are removed when you delete the app.
        </Li>

        {/* ------------------------------------------------------------ */}
        <H id="how-we-use">2. How We Use Information</H>
        <Li>To create and deliver the results you request.</Li>
        <Li>
          To check photos and results for unsafe content and to enforce our
          rules (see “Safety, Moderation and Reporting”).
        </Li>
        <Li>To verify your subscription and provide paid features.</Li>
        <Li>To prevent fraud and abuse and to apply usage limits.</Li>
        <Li>To maintain, secure and improve the app.</Li>
        <Li>To respond to your reports and support requests.</Li>
        <P>
          We do not use your photos or face data for advertising, marketing,
          profiling, identification, authentication, or data mining, and we do
          not allow our providers to do so on our behalf. Data collected for one
          purpose is not reused for a different purpose without your further
          consent, unless the law permits it.
        </P>

        {/* ------------------------------------------------------------ */}
        <H id="third-party-ai">3. Third-Party AI and Service Providers</H>

        <P>
          The photo you choose to submit and the hairstyle or hair color you
          pick are sent over an encrypted connection through our server to the
          following third-party services. We only do this after you give
          permission in the app.
        </P>

        <SH>Image generation</SH>
        <Li>
          Replicate, Inc. runs the AI image models used to create your results,
          including models published by Google (for example Nano Banana / Gemini
          image models). Your photo and your selection are processed by these
          services only to create your result.
        </Li>
        <Li>
          Privacy policy:{" "}
          <Ext href="https://replicate.com/privacy">
            https://replicate.com/privacy
          </Ext>
        </Li>

        <SH>Safety checks</SH>
        <Li>
          OpenAI, L.L.C. checks your photo and the generated result for unsafe
          content with its moderation service. It is not used to analyze or rate
          your appearance.
        </Li>
        <Li>
          Privacy policy:{" "}
          <Ext href="https://openai.com/policies/privacy-policy">
            https://openai.com/policies/privacy-policy
          </Ext>
        </Li>

        <SH>Other service providers</SH>
        <Li>
          Supabase hosts the server components that receive your request and
          pass it to the services above.
        </Li>
        <Li>
          RevenueCat processes subscription status:{" "}
          <Ext href="https://www.revenuecat.com/privacy/">
            https://www.revenuecat.com/privacy/
          </Ext>
        </Li>
        <Li>
          Google Firebase (Analytics):{" "}
          <Ext href="https://firebase.google.com/support/privacy">
            https://firebase.google.com/support/privacy
          </Ext>
        </Li>
        <Li>
          Apple (App Store) and Google (Google Play) process payments and
          subscriptions under their own terms.
        </Li>

        <P>
          We share data only with providers needed to operate the app, and we
          select providers that give the same or an equal level of protection of
          user data as described in this policy and required by the App Store
          Review Guidelines. These providers process your data under their own
          privacy policies, including how long they retain it, so please review
          them. We do not sell, rent or share your photos or face data with any
          other third parties.
        </P>

        {/* ------------------------------------------------------------ */}
        <H id="face-data-processing">4. Face and Photo Data</H>

        <P>
          To comply with App Store review guidelines, we provide the following
          information about face and photo data:
        </P>

        <SH>What we collect</SH>
        <Li>
          The photo that you voluntarily select or take, which may contain your
          face, so that the app can change your hairstyle or hair color in it.
        </Li>
        <Li>
          We only process the photo itself. We do not create, extract or store
          biometric identifiers or face templates (such as facial recognition
          data), and we do not use face mapping or depth data.
        </Li>

        <SH>What we do with it</SH>
        <Li>
          The photo is used only to provide the result you asked for and to
          check it for unsafe content.
        </Li>
        <Li>
          It is not used for identification, authentication, advertising,
          marketing, profiling or data mining, by us or by third parties.
        </Li>
        <Li>Processing happens in near real time when you request a result.</Li>

        <SH>Where it goes and how long it stays</SH>
        <Li>
          Our servers pass your photo to the providers in section 3 and do not
          save a copy of it. A record of the generated result (an ID and
          timestamp, not the photo) is kept as described in section 6.
        </Li>
        <Li>
          How long the providers keep data is decided by them, not by us, and it
          can change at any time. We do not control it and cannot guarantee it.
          Please check each provider’s current privacy policy (linked in section
          3) for how long it keeps your data. Generated results are available to
          your device through a link provided by the image service and are saved
          on your device.
        </Li>
        <Li>
          If you report a result, the report includes only the result’s ID, not
          the photo or the image, so we can find the related request and act on
          it.
        </Li>

        <SH>Security</SH>
        <Li>
          All data transmission is encrypted using industry-standard protocols.
        </Li>
        <Li>
          We apply appropriate technical and organizational measures to protect
          your data, such as access limits on our servers and abuse protection.
        </Li>

        {/* ------------------------------------------------------------ */}
        <H id="consent">5. Consent and How to Withdraw It</H>
        <Li>
          Before your photo is sent to a third-party AI service, the app clearly
          shows which services receive the data and asks for your explicit
          permission. The app does not send it without that permission.
        </Li>
        <Li>
          You can withdraw this permission at any time in the app under Settings
          → Withdraw AI Data Consent. After that, the app asks again before
          sending your next photo. You can also simply stop using the AI
          features or delete the app.
        </Li>
        <Li>
          You choose which photo to submit, and you can choose not to upload any
          facial images at any time. Processing happens only when you request a
          result.
        </Li>
        <Li>
          You can revoke photo and camera access at any time in your device
          settings.
        </Li>
        <Li>
          Paid features do not depend on you agreeing to analytics or tracking.
        </Li>

        {/* ------------------------------------------------------------ */}
        <H id="retention">6. Data Retention and Deletion</H>
        <Li>
          We do not keep copies of your photos on our servers. Data on your
          device stays until you delete the app or its data.
        </Li>
        <Li>
          Short-term technical records (such as request counters and the IP
          address used for rate limiting) are kept for a few days and then
          removed.
        </Li>
        <Li>
          Records that link a result to your anonymous app user ID, and reports
          you send us, are kept only for a limited period and are deleted
          regularly. We may keep them longer only where needed for an ongoing
          abuse investigation or a legal obligation.
        </Li>
        <Li>
          Analytics and purchase data are kept by Firebase, RevenueCat, Apple
          and Google under their retention policies.
        </Li>
        <P>
          To request deletion of your data, or to ask questions about it, email{" "}
          <Ext href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Ext> with
          details about your use (for example the app name and approximate
          dates). We will make reasonable efforts to find and delete the data
          connected to your request, and to ask our providers to do the same
          where applicable.
        </P>

        {/* ------------------------------------------------------------ */}
        <H id="safety">7. Safety, Moderation and Reporting</H>
        <Li>
          We check photos and results for unsafe content, including nudity,
          sexual content, content involving minors, and violent or hateful
          content. Photos or results that fail these checks are blocked.
        </Li>
        <Li>
          You can report any result inside the app with the Report button, or in
          Settings, or by emailing{" "}
          <Ext href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Ext>. We review
          reports and may remove content or restrict access for anonymous app
          user IDs that break our rules.
        </Li>
        <Li>
          Where required by law, we may disclose information to the relevant
          authorities, for example about illegal content.
        </Li>

        {/* ------------------------------------------------------------ */}
        <H id="children">8. Children</H>
        <P>
          The photo features of <App /> are intended for users aged 18 and over.
          We do not knowingly collect personal information from anyone under 18,
          and these features must not be used with photos of anyone under 18. If
          you believe a minor’s information has been submitted, contact us and
          we will take steps to remove it.
        </P>

        {/* ------------------------------------------------------------ */}
        <H id="tracking">9. Tracking and Advertising</H>
        <Li>
          The app may ask for your permission to use your device’s advertising
          identifier (the App Tracking Transparency prompt on iOS, and the
          advertising ID permission on Android).
        </Li>
        <Li>
          If you allow it, the identifier is available to our analytics provider
          (Google Firebase) and is used for app analytics and for measuring the
          app’s performance.
        </Li>
        <Li>
          We do not show advertising in the app and we do not sell your personal
          information. Your photos and face data are not used for advertising or
          marketing.
        </Li>
        <Li>
          If you decline, the app works the same. You can change your choice at
          any time: on iOS in Settings → Privacy &amp; Security → Tracking, and
          on Android in Settings → Privacy → Ads.
        </Li>

        {/* ------------------------------------------------------------ */}
        <H id="your-rights">10. Your Rights and Choices</H>
        <P>
          Depending on where you live (for example in the EU/EEA, UK or
          California), you may have the right to access, correct, delete or
          restrict the use of your personal data, to object to processing, to
          withdraw consent, and to complain to your local data protection
          authority. Where we rely on your consent (such as sending photos to AI
          services), you can withdraw it at any time as described above. To
          exercise a right, contact us at{" "}
          <Ext href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Ext>.
        </P>

        <H id="transfers">11. International Data Transfers</H>
        <P>
          Our providers may process data in countries other than your own,
          including the United States. By giving your permission in the app, you
          agree to this transfer, which is subject to the safeguards and
          policies of those providers.
        </P>

        <H id="changes">12. Changes to This Policy</H>
        <P>
          We may update this policy from time to time. The latest version is
          always available at this page, with the effective date shown above. If
          we make material changes to how your data is used, we will ask for
          your permission again in the app where required.
        </P>

        <H id="contact">13. Contact</H>
        <P>
          Questions, requests or reports:{" "}
          <Ext href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Ext>
        </P>

        <H id="terms">14. Terms of Use</H>
        <P>
          Your use of <App /> is also subject to our{" "}
          <Link
            to="/hairtryon/termsofuse"
            style={{ textDecoration: "underline", color: "#fff" }}
          >
            Terms of Use
          </Link>
          , which cover the license, subscriptions, acceptable use, disclaimers
          and governing law.
        </P>

        <Text fontSize="s" color="#fff" mt={10} textAlign="right">
          Last updated: {EFFECTIVE_DATE}
        </Text>

        <Text
          fontSize="xl"
          color="#fff"
          fontWeight="hairline"
          mt={20}
          mb={0}
          align="right"
        >
          Muhammed Deniz
        </Text>

        <Text
          fontSize="s"
          color="#fff"
          fontWeight="hairline"
          mt={0}
          mb={2}
          align="right"
        >
          <App />
        </Text>

        <Text fontSize="s" color="#fff" mb={20} align="right">
          Contact: <Ext href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Ext>
        </Text>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
